document.addEventListener('DOMContentLoaded', () => {
    const stateManager = window.AppState;

    if (!window.authService.isAuth()) {
        return window.authService.redirectToAuth();
    }

    syncStateFromURL(stateManager);

    window.authService.updateUserState()
        .then(user => {

            window.authService.redirectToApp();

            // Инициализация UI
            initUI(stateManager);

            // Подписка на изменения состояния
            stateManager.subscribe(updateUI);

            stateManager.subscribe(state => {
                updateURLFromState(state);
            });
        })
        .catch(err => {
            window.__log(err);
        });

});

function syncStateFromURL(stateManager) {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('page');

    if (page && ['dashboard', 'alerts', 'portfolio'].includes(page)) {
        stateManager.updateState(state => ({
            ui: {
                ...state.ui,
                currentPage: page
            }
        }));
    }
}

function updateURLFromState(state) {
    const url = new URL(window.location);
    url.searchParams.set('page', state.ui.currentPage);
    window.history.pushState({}, '', url);
}

function initUI(stateManager) {
    // Обработчики для нижнего меню
    document.querySelectorAll('.bottom-nav .nav-link').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const page = link.getAttribute('data-page');

            // Удаляем активный класс у всех ссылок
            document.querySelectorAll('.bottom-nav .nav-link').forEach(l => {
                l.classList.remove('active');
            });

            // Добавляем активный класс текущей ссылке
            link.classList.add('active');

            // Обновляем состояние
            stateManager.updateState(state => ({
                ui: {
                    ...state.ui,
                    currentPage: page
                }
            }));
        });
    });

    // Выбор криптопары
    // document.getElementById('base-currency').addEventListener('change', () => updatePair(stateManager));
    // document.getElementById('quote-currency').addEventListener('change', () => updatePair(stateManager));

    // Кнопка обновления
    // document.getElementById('get-price-btn').addEventListener('click', () => loadCryptoData(stateManager));

    document.querySelector('#exit-btn').addEventListener('click', (e) => {
        window.authService.signOut();
        window.authService.redirectToAuth();
    });
}

function updateUI(state) {
    if (!state.auth.user) {
        return window.authService.redirectToAuth();
    }


    // Обновление активного пункта меню
    document.querySelectorAll('.bottom-nav .nav-link').forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('data-page') === state.ui.currentPage) {
            link.classList.add('active');
        }
    });

    // Обновление страницы
    document.querySelectorAll('.page').forEach(p => p.classList.add('hidden'));
    document.getElementById(`${state.ui.currentPage}-page`).classList.remove('hidden');
    document.querySelector('.page-title').textContent = getPageTitle(state.ui.currentPage);

    // Обновление темы
    // document.body.className = state.ui.theme;

    // Обновление данных пользователя
    // if (state.auth.user) {
    // const userElements = {
    //     name: document.querySelector('.user-name'),
    //     email: document.querySelector('.user-email'),
    //     avatar: document.querySelector('.avatar')
    // };

    // if (userElements.name) userElements.name.textContent = state.auth.user.name;
    // if (userElements.email) userElements.email.textContent = state.auth.user.email;
    // if (userElements.avatar) userElements.avatar.textContent = state.auth.user.name.charAt(0);
    // }

    // Обновление криптоданных
    // if (state.crypto.priceData) {
    // document.getElementById('pair-name').textContent = state.crypto.selectedPair;
    // document.getElementById('current-price').textContent = state.crypto.priceData.price;
    // ... другие обновления UI
    // }

    // Обновление уведомлений
    window.__notify.renderNotifications(state.ui.notifications);
}


// function updatePair(stateManager) {
//     const base = document.getElementById('base-currency').value;
//     const quote = document.getElementById('quote-currency').value;
//     const pair = `${base}/${quote}`;

//     stateManager.updateState(state => ({
//         crypto: {
//             ...state.crypto,
//             selectedPair: pair
//         }
//     }));

//     loadCryptoData(stateManager);
// }

// async function loadCryptoData(stateManager) {
//     try {
//         const pair = stateManager.getState().crypto.selectedPair;

//         stateManager.updateState(state => ({
//             crypto: {
//                 ...state.crypto,
//                 isLoading: true,
//                 error: null
//             }
//         }));

//         // Мок запроса (замените на реальный API-вызов)
//         const priceData = await mockFetchCryptoPrice(pair);

//         stateManager.updateState(state => ({
//             crypto: {
//                 ...state.crypto,
//                 priceData,
//                 isLoading: false
//             },
//             ui: {
//                 ...state.ui,
//                 notifications: [
//                     {
//                         id: Date.now(),
//                         message: `Данные по ${pair} обновлены`,
//                         type: 'success'
//                     }
//                 ]
//             }
//         }));
//     } catch (error) {
//         stateManager.updateState(state => ({
//             crypto: {
//                 ...state.crypto,
//                 isLoading: false,
//                 error: error.message
//             },
//             ui: {
//                 ...state.ui,
//                 notifications: [
//                     {
//                         id: Date.now(),
//                         message: `Ошибка: ${error.message}`,
//                         type: 'error'
//                     }
//                 ]
//             }
//         }));
//     }
// }



// Вспомогательные функции
function getPageTitle(page) {
    const titles = {
        dashboard: 'Дашборд',
        alerts: 'Оповещения',
        portfolio: 'Портфель'
    };
    return titles[page] || 'Traders Bay';
}

async function mockFetchCryptoPrice(pair) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                pair,
                price: (Math.random() * 50000).toFixed(2),
                change: (Math.random() * 10 - 5).toFixed(2),
                high: (Math.random() * 51000).toFixed(2),
                low: (Math.random() * 49000).toFixed(2)
            });
        }, 1000);
    });
}




// Функция для запроса автокомплита (без изменений)
async function fetchAutocompletePairs(query) {
    try {
        const response = await window.ajax.get('/bb/search?symbol=' + query);
        window.__log('fetchAutocompletePairs response', response);

        if (response.error === 1) {
            window.__notify.errorNotify(response.message, 'error');
            return [];
        }

        return response.data.pairs;
    } catch (error) {
        window.__log(error);
        window.__notify.errorNotify('Ошибка при загрузке вариантов', 'error');
        return [];
    }
}

// Функция для обработки автокомплита
async function handleAutocomplete(query) {
    const autocompleteContainer = document.getElementById('autocomplete-container');
    document.getElementById('alert-pair-price').value = '';

    if (query.length < 3) {
        autocompleteContainer.classList.add('hidden');
        return;
    }

    // Показываем индикатор загрузки
    autocompleteContainer.innerHTML = '<div class="autocomplete-item">Загрузка...</div>';
    autocompleteContainer.classList.remove('hidden');

    const pairs = await fetchAutocompletePairs(query);

    if (pairs.length === 0) {
        autocompleteContainer.innerHTML = '<div class="autocomplete-item">Ничего не найдено</div>';
        return;
    }
    // Очищаем и заполняем контейнер автокомплита
    autocompleteContainer.innerHTML = '';
    pairs.forEach(pair => {
        const item = document.createElement('div');
        item.className = 'autocomplete-item';
        item.textContent = pair;
        item.addEventListener('click', () => {
            document.getElementById('alert-pair-input').value = pair;
            autocompleteContainer.classList.add('hidden');
            window.ajax.get('/bb/price?symbol=' + pair).then(result => {
                if (result.error === 0) {
                    if (result.data && result.data.lastPrice) {
                        document.getElementById('alert-pair-price').value = result.data.lastPrice;
                    }
                }
            });

        });
        autocompleteContainer.appendChild(item);
    });
}

// Функция для создания debounce
function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

// Создаем debounce-версию функции с задержкой 300мс
const debouncedHandleAutocomplete = debounce(handleAutocomplete, 300);

// Обработчик ввода в поле поиска пары
document.getElementById('alert-pair-input')?.addEventListener('input', (e) => {
    const query = e.target.value.trim();
    debouncedHandleAutocomplete(query);
});

// Скрываем автокомплит при клике вне его
document.addEventListener('click', (e) => {
    const autocompleteContainer = document.getElementById('autocomplete-container');
    const pairInput = document.getElementById('alert-pair-input');

    if (e.target !== pairInput && !autocompleteContainer.contains(e.target)) {
        autocompleteContainer.classList.add('hidden');
    }
});







// Регистрация Service Worker для PWA
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('sw.js').then(registration => {
            console.log('ServiceWorker registration successful');
        }).catch(err => {
            console.log('ServiceWorker registration failed: ', err);
        });
    });
}